import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FeahterIconModule } from 'src/app/core/feather-icon/feather-icon.module';
import { DeleteDatafieldComponent } from './delete-datafield/delete-datafield.component';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { SharedButtonsModule } from 'src/app/views/shared/components/buttons/shared-buttons.module';
import { EditDatasheetSectionsOrderComponent } from './edit-datasheet-sections-order/edit-datasheet-sections-order.component';


@NgModule({
  declarations: [
    DeleteDatafieldComponent,
    EditDatasheetSectionsOrderComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    FeahterIconModule,
    SharedButtonsModule,
    SweetAlert2Module.forRoot()
  ],
  exports: [
    DeleteDatafieldComponent,
    EditDatasheetSectionsOrderComponent
  ]
})
export class PepComponentsModule { }
